import { parseContract } from '../contracts/generated/contracts.js';

const PREFIX = 'corecry:home-snapshot:v1:';
const TTL = 24 * 60 * 60 * 1000;
const MAX_BYTES = 1024 * 1024;

export function readHomeSnapshot(identity) {
    if (!identity) return null;
    try {
        const value = JSON.parse(localStorage.getItem(PREFIX + identity) || 'null');
        if (!value || value.identity !== identity || !Number.isFinite(value.savedAt) ||
            Date.now() < value.savedAt || Date.now() - value.savedAt > TTL) return null;
        parseContract('home_news_feed', value.feed);
        return value;
    } catch { return null; }
}

export function writeHomeSnapshot(identity, feed) {
    if (!identity) return;
    try {
        parseContract('home_news_feed', feed);
        const value = JSON.stringify({ identity, savedAt: Date.now(), feed });
        if (value.length * 2 <= MAX_BYTES) localStorage.setItem(PREFIX + identity, value);
    } catch { /* Storage is an optional rendering cache. */ }
}

export function readHomeSection(identity, section) {
    if (!identity || !['calendar', 'recommended'].includes(section)) return null;
    try {
        const value = JSON.parse(localStorage.getItem(`${PREFIX}${identity}:${section}`) || 'null');
        if (!value || value.identity !== identity || !Array.isArray(value.items) || !Number.isFinite(value.savedAt) ||
            Date.now() < value.savedAt || Date.now() - value.savedAt > TTL) return null;
        return value;
    } catch { return null; }
}

export function writeHomeSection(identity, section, items) {
    if (!identity || !['calendar', 'recommended'].includes(section) || !Array.isArray(items)) return;
    try {
        const value = JSON.stringify({ identity, savedAt: Date.now(), items });
        if (value.length * 2 <= MAX_BYTES) localStorage.setItem(`${PREFIX}${identity}:${section}`, value);
    } catch { /* Storage is optional. */ }
}

export function clearHomeSnapshots() {
    try {
        for (let i = localStorage.length - 1; i >= 0; i--) {
            const key = localStorage.key(i);
            if (key?.startsWith(PREFIX)) localStorage.removeItem(key);
        }
    } catch { /* Storage is an optional rendering cache. */ }
}
